const SCROLL_DELAY_MS = 100

const scrollToFirstError = () => {
  setTimeout(() => {
    const firstInvalidField = document.querySelector('.is-invalid')
    if (firstInvalidField)
      firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' })
    else
      window.scrollTo({ top: 0, behavior: 'smooth' })
  }, SCROLL_DELAY_MS)
}

export default scrollToFirstError
